import React from "react";

import { Group, Line } from "react-konva";
import { useTheme } from "@mui/material";

import Element from "../Element";
import { IElement } from "../Element/types/IElement";
import { ROW_HEIGHT_IN_PX, RULER_HEIGHT_IN_PX } from "../../constants";

interface RowProps {
  elements: IElement[];
  allElements: IElement[];
  rowIndex: number;
  onElementChange: (element: IElement) => void;
  onElementSelect?: (element: IElement) => void;
  onContextMenu?: (element: IElement, x: number, y: number) => void;
  pixelsPerMillisecond: number;
  numberOfRows: number;
  playheadTimeMs: number;
  timelineWidth: number;
  videoDurationMs: number;
}

export default function Row({
  elements,
  allElements,
  rowIndex,
  onElementChange,
  onElementSelect,
  onContextMenu,
  pixelsPerMillisecond,
  numberOfRows,
  playheadTimeMs,
  timelineWidth,
  videoDurationMs,
}: RowProps) {
  const theme = useTheme();
  const rowSeparatorColor =
    theme.palette.mode === "dark" ? "#2a2b3d" : "#e0e0e0";

  const rowY = RULER_HEIGHT_IN_PX + rowIndex * ROW_HEIGHT_IN_PX;
  return (
    <Group y={rowY}>
      <Line
        points={[0, ROW_HEIGHT_IN_PX, timelineWidth, ROW_HEIGHT_IN_PX]}
        stroke={rowSeparatorColor}
        strokeWidth={1}
        listening={false}
      />
      {elements.map((element) => (
        <Element
          key={element.id}
          element={element}
          allElements={allElements}
          onElementChange={onElementChange}
          onElementSelect={onElementSelect}
          onContextMenu={onContextMenu}
          pixelsPerMillisecond={pixelsPerMillisecond}
          numberOfRows={numberOfRows}
          playheadTimeMs={playheadTimeMs}
          videoDurationMs={videoDurationMs}
        />
      ))}
    </Group>
  );
}
